import Vue from 'vue'
import Screen from '@/components/Screen'
import Setting from '@/components/Setting'
import Editor from '@/components/editor'
import Library from '@/components/library'
import Group from '@/components/library/group'
import Material from '@/components/library/material'
import Container from '@/components/editor/container'

const Components = [
  Screen,
  Editor,
  Setting,
  Library,
  Group,
  Material,
  Container
]

Components.map(Component => {
  console.log('name:', Component.name)
  Vue.component(Component.name, Component)
})

export default {
  Screen,
  Editor,
  Setting,
  Library,
  Group,
  Material,
  Container
}
